import { DIVISIONS } from "@/lib/divisions";

export default function DivisionTabs({ value, onChange, testid }) {
  return (
    <div className="flex overflow-hidden rounded-sm border border-bline" data-testid={testid}>
      {DIVISIONS.map((d) => (
        <button
          key={d.key}
          type="button"
          data-testid={`${testid}-${d.key}`}
          onClick={() => onChange(d.key)}
          className={`px-3 py-1 font-display text-sm tracking-widest transition-colors duration-150 ${
            value === d.key ? "bg-volt text-ink" : "bg-surface/60 text-slate-400 hover:text-volt"
          }`}
        >
          {d.label}
        </button>
      ))}
    </div>
  );
}
